/**
 * What the shopper is told about where a placed order ships, as the server
 * writes it (GET /api/orders/<id>/ship-to, api/src/endpoints/order.py,
 * api/src/services/store_ship_to.py).
 *
 * Card #402 (Jake, 2026-10-23): when the store presets the ship-to the
 * shopper enters no address, so every order surface says
 * "Ships to <name, address>, set by <store>". The sentence, and the line
 * saying what the address is ("Shipping to your company's address"), are the
 * server's; no surface composes or labels them itself.
 *
 * Shape: { source, meaning, disclosure }. `disclosure` is null when the
 * shopper typed the address (they know it) and on a legacy order.
 */

/**
 * Fetch an order's ship-to. Resolves to null when the read fails (a refused
 * or missing order answers 404), so a caller keeps the rest of its page.
 * `config` is an optional axios request config (the order page's
 * skip-auth-recovery flag).
 */
export async function fetchOrderShipTo(axios, orderId, config) {
  if (!axios || orderId == null) return null;
  try {
    const url = `/orders/${orderId}/ship-to`;
    const res = await (config ? axios.get(url, config) : axios.get(url));
    const shipTo = res && res.data && res.data.ship_to;
    return shipTo && typeof shipTo === "object" ? shipTo : null;
  } catch (err) {
    return null;
  }
}
